module.exports = __webpack_public_path__ + "./img/logoDarsur-footer.8836751733a28aea4c1c6aee9b116e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoDarsur-footer.png
// module id = ./src/assets/img/logoDarsur-footer.png
// module chunks = 14